import React, { PureComponent } from 'react';
import { Radio, RadioChangeEvent, Space } from 'antd';
import { TimePeriod } from 'app/model/CORE';
import AppContext from 'app/common/context/AppContext';
import TimeUtils from 'app/common/util/TimeUtils';
import TimePeriodUtils from 'app/common/util/TimePeriodUtils';
import memoizeOne from 'memoize-one';

const dwdTimePeriods = [
    {
        from: new Date(6 * TimeUtils.HR_TO_MS),
        to: new Date(9 * TimeUtils.HR_TO_MS),
    },
    {
        from: new Date(9 * TimeUtils.HR_TO_MS),
        to: new Date(12 * TimeUtils.HR_TO_MS),
    },
    {
        from: new Date(12 * TimeUtils.HR_TO_MS),
        to: new Date(15 * TimeUtils.HR_TO_MS),
    },
    {
        from: new Date(15 * TimeUtils.HR_TO_MS),
        to: new Date(18 * TimeUtils.HR_TO_MS),
    },
    {
        from: new Date(18 * TimeUtils.HR_TO_MS),
        to: new Date(21 * TimeUtils.HR_TO_MS),
    },
];

export class DwdTPShortcut extends PureComponent<{
    value: Date | TimePeriod;
    onChange: (timePeriods: TimePeriod) => void;
}> {
    render = () => (
        <Radio.Group
            style={{ paddingBottom: '0.5em' }}
            value={this.getDwdTimePeriod(this.props.value)}
            buttonStyle="solid"
            size="small"
            onChange={this.onChange}
            className={'dwd-tp-shortcut'}>
            <Space.Compact direction="horizontal">
                {Array(5)
                    .fill(0)
                    .map((_, i) => this.renderRadioButton(i))}
            </Space.Compact>
        </Radio.Group>
    );

    private onChange = (e: RadioChangeEvent) => {
        const value: TimePeriod = e.target.value;
        const timePeriod = {
            from: TimeUtils.mergeDateAndTime(AppContext.getMonitoredDay(), value.from),
            to: TimeUtils.mergeDateAndTime(AppContext.getMonitoredDay(), value.to),
        };
        this.props.onChange(timePeriod);
    };

    private renderRadioButton(idx: number) {
        const timePeriod = dwdTimePeriods[idx];
        return (
            <Radio.Button key={idx} value={timePeriod} className={this.className()}>
                {TimePeriodUtils.formatHH(timePeriod)}
            </Radio.Button>
        );
    }

    private getDwdTimePeriod = memoizeOne((refTime: Date | TimePeriod): TimePeriod => {
        let refTimeMs: Date | TimePeriod;
        if (refTime instanceof Date) {
            refTimeMs = new Date(TimeUtils.timeSinceMidnightInMs(refTime));
        } else {
            refTimeMs = {
                from: new Date(TimeUtils.timeSinceMidnightInMs(refTime.from)),
                to: new Date(TimeUtils.timeSinceMidnightInMs(refTime.to)),
            };
        }
        const timePeriods = dwdTimePeriods.filter(timePeriod => TimePeriodUtils.intersects(timePeriod, refTimeMs));
        return timePeriods.length === 1 ? timePeriods[0] : undefined;
    });

    private className = () => (AppContext.isForecast() ? 'pretact' : 'tact');
}
